import { IUserInfo } from 'graphql/competition/UserInfo'
import { agent } from 'pages/TradingCompetition/api/agent'
import { TaskStatus } from 'pages/TradingCompetition/api/interfaces/task.interface'
import { useEffect, useMemo, useState } from 'react'
import { nowInSeconds } from 'utils/date'

import { ITaskWithContent } from '../interfaces/task-with-content.interface'
import { TwitterConnect } from '../TaskItems/twitter-connect'

const confirmTask = async (data: { id: number; wallet: string }) => {
  try {
    const res = await agent.competition.confirmTask(data)
    console.log(res)
  } catch (e) {
    console.error(e)
  }
}

const TASK_CONTENTS: any = {
  1: <TwitterConnect confirmTask={confirmTask} />,
  8: <TwitterConnect confirmTask={confirmTask} />,
}

const useTasksByWallet = ({ userInfo, account }: { account?: string; userInfo: IUserInfo }) => {
  const [tasks, setTasks] = useState<ITaskWithContent[]>([])
  const { getTasksByWallet } = agent.competition

  const activeTask = useMemo(() => {
    if (
      userInfo.isLoading ||
      !userInfo.data ||
      !userInfo.data.user ||
      !userInfo.data.user.taskIds ||
      userInfo.data.user.taskIds.length === 0 ||
      nowInSeconds() > Number(userInfo.data.user.multiplierEnd)
    )
      return 0
    const activeTaskId = userInfo.data.user.taskIds[userInfo.data.user.taskIds.length - 1]
    return Number(activeTaskId)
  }, [userInfo])

  const lastTask = useMemo(() => {
    if (
      userInfo.isLoading ||
      !userInfo.data ||
      !userInfo.data.user ||
      !userInfo.data.user.taskIds ||
      userInfo.data.user.taskIds.length === 0
    )
      return 0
    return userInfo.data.user.taskIds[userInfo.data.user.taskIds.length - 1]
  }, [userInfo])

  const fetchTasks = async (account: string) => {
    const res = await getTasksByWallet(account)
    if (!userInfo.data || !userInfo.data.user) return

    const updatedStatuses = res.map((task, i) => {
      let status: TaskStatus
      if (task.id === activeTask) {
        status = TaskStatus.ACTIVE
      } else if (
        userInfo?.data?.user?.taskIds?.includes(task.id.toString()) ||
        (activeTask === 0 && task.id === Number(lastTask))
      ) {
        status = TaskStatus.USED
        //@ts-ignore
      } else if (task.status === 'INITIAL') {
        status = TaskStatus.INITIAL
        //@ts-ignore
      } else if (task.status === 'PENDING') {
        status = TaskStatus.PENDING
        //@ts-ignore
      } else {
        status = TaskStatus.CONFIRMED
      }
      //  else if (task.status === 'SUCCESS') {
      //   status = TaskStatus.CONFIRMED
      // }
      return { ...task, status, content: TASK_CONTENTS[task.id] || undefined }
    })

    setTasks(updatedStatuses)
  }

  useEffect(() => {
    if (!account) return
    fetchTasks(account)
  }, [account, activeTask, lastTask, userInfo])

  return useMemo(() => {
    return tasks
  }, [tasks])
}

export default useTasksByWallet
